import { useEffect, useState } from 'react'
import { ownedPromptsApi } from '../../api/owned-prompts'
import PromptsWorkspace from '../../components/prompts/PromptsWorkspace'
import LegacyOrgPromptsPage from './LegacyOrgPromptsPage'

export default function OrgPromptsPage() {
  const [mode, setMode] = useState<'legacy' | 'owned' | 'maintenance' | 'error' | null>(null)

  useEffect(() => {
    let cancelled = false
    ownedPromptsApi
      .capabilities()
      .then((caps) => {
        if (!cancelled) {
          setMode(caps.mode)
        }
      })
      .catch(() => {
        if (!cancelled) setMode('error')
      })
    return () => {
      cancelled = true
    }
  }, [])

  if (mode === null) {
    return (
      <p className="px-6 py-10 text-center text-sm text-harbor-text-secondary">Loading prompts…</p>
    )
  }
  if (mode === 'error') {
    return (
      <p className="px-6 py-10 text-center text-sm font-medium text-red-300">
        Failed to load the prompt library. Try reloading the page.
      </p>
    )
  }
  if (mode === 'maintenance') {
    return (
      <p className="px-6 py-10 text-center text-sm text-harbor-text-secondary">
        Prompt library migration is in progress. Try again shortly.
      </p>
    )
  }
  if (mode === 'legacy') {
    return <LegacyOrgPromptsPage />
  }
  return <PromptsWorkspace showCatalogLink />
}
